import type { MedicalGroupList } from '@pba/react-network';
import type { LabelInValue } from 'models';
import { useCallback } from 'react';

export const useMedicalGroupPickerCreateLabelInValueOption = () =>
  useCallback(
    (option: MedicalGroupList): LabelInValue => ({
      label: option.name,
      value: option.id,
    }),
    [],
  );
